import { render, staticRenderFns } from "./ProfilRumahSakit.vue?vue&type=template&id=c8b53412"
import script from "./ProfilRumahSakit.vue?vue&type=script&lang=js"
export * from "./ProfilRumahSakit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8b53412')) {
      api.createRecord('c8b53412', component.options)
    } else {
      api.reload('c8b53412', component.options)
    }
    module.hot.accept("./ProfilRumahSakit.vue?vue&type=template&id=c8b53412", function () {
      api.rerender('c8b53412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/identitas-rumah-sakit/ProfilRumahSakit.vue"
export default component.exports